"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/** @module resolve */ /** for typedoc */
__export(require("./interface"));
__export(require("./resolvable"));
__export(require("./resolveContext"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uirouter/core/lib/resolve/index.js
// module id = 363
// module chunks = 0